import styled from 'styled-components';
import { Link } from 'react-router-dom';
import SeoMeta from '../components/SeoMeta';
import { usePageMeta } from '../hooks/usePageMeta';

const Wrap = styled.main`
  min-height: 60vh;
  display: grid;
  place-items: center;
  text-align: center;
  padding: 80px 16px;
  .inner {
    max-width: 560px;
    display: grid;
    gap: 16px;
  }
  h1 {
    font-size: clamp(48px, 10vw, 72px);
    margin: 0;
  }
  p {
    margin: 0;
    color: ${({ theme }) => theme.textMuted};
  }
  a {
    color: ${({ theme }) => theme.accent};
    font-weight: 600;
    text-decoration: none;
  }
`;

export default function NotFound() {
  const meta = usePageMeta('notFound');

  return (
    <Wrap>
      <SeoMeta
        title={meta.title}
        description={meta.description}
        keywords={meta.keywords}
        image={meta.image}
        path={meta.path || '/404'}
        noIndex={meta.noIndex ?? true}
      />
      <div className="inner">
        <h1>404</h1>
        <p>{meta.description || 'Сторінку не знайдено.'}</p>
        <Link to="/">Повернутися на головну</Link>
      </div>
    </Wrap>
  );
}
